import axios from 'axios'
import { LooseObject } from '@interflora/ui-components/build/common/props'

const AZURE_MAPS_KEY =
  process.env.NEXT_PUBLIC_SITE_KEY === 'interflora-co-uk'
    ? process.env.NEXT_PUBLIC_AZURE_MAPS_KEY_UK
    : process.env.NEXT_PUBLIC_AZURE_MAPS_KEY_IE

const AZURE_MAPS_CLIENT_ID =
  process.env.NEXT_PUBLIC_SITE_KEY === 'interflora-co-uk'
    ? process.env.NEXT_PUBLIC_AZURE_MAPS_CLIENT_ID_UK
    : process.env.NEXT_PUBLIC_AZURE_MAPS_CLIENT_ID_IE

const AZURE_MAPS_ENDPOINT = process.env.NEXT_PUBLIC_AZURE_MAPS_ENDPOINT

/**
 * Azure Maps Integration
 */
export async function findLocation(data: LooseObject) {
  try {
    return await axios.get(`${AZURE_MAPS_ENDPOINT}/search/address/json`, {
      params: {
        query: data.location,
        'subscription-key': AZURE_MAPS_KEY,
        'client-id': AZURE_MAPS_CLIENT_ID,
      },
    })
  } catch (error) {
    throw new Error(`There was a problem loading that location, please try again. Error: ${error.message}`)
  }
}
